import { useDispatch, useSelector } from "react-redux";

import { calcActions } from "../actions/calc";
import { calcData } from "../../helpers/calcData";

export const useCalc = () => {
  const dispatch = useDispatch();
  const { stepOneData, stepTwoData, stepThree } = useSelector((state) => state.calc);

  const {max, size, bet} = stepOneData;

  const fields = Array.from({ length: stepOneData.max }, (v, k) => k);
  const initialValues = fields.reduce((a,b)=> {
    return {...a,[`bet${b}`]:'', [`betStatus${b}`]:false}
  },{});

  const setStepOneData = (payload) => dispatch(calcActions.setStepOneData(payload));
  const clearStepOneData = () => dispatch(calcActions.clearStepOneData());

  const setStepTwoData = (payload) => dispatch(calcActions.setStepTwoData(payload));
  const clearStepTwoData = () => dispatch(calcActions.clearStepTwoData());

  const showStepThree = (payload) => dispatch(calcActions.showStepThree(payload));

  const clearAll = () => dispatch(calcActions.clearAll());

  const calc = () => calcData(max, size, bet, stepTwoData);

  return {
    stepOneData,
    stepTwoData,
    stepThree,
    setStepOneData,
    setStepTwoData,
    clearStepOneData,
    clearStepTwoData,
    showStepThree,
    clearAll,
    calc,
    fields,
    initialValues,
  }
};
